import { AjaxClient } from "app/common/ajax";
import { initializeTabs } from "app/common/tabs";
import * as $ from "jquery";

export class UserManager {
    private readonly ajaxClient: AjaxClient;
    private readonly userId: number;

    public constructor(userId: number, ajaxClient: AjaxClient) {
        this.ajaxClient = ajaxClient;
        this.userId = userId;

        initializeTabs($('#user-tabs'));

        // Edit name checkbox
        $('#edit-username').on('click', (evt) => {
            const canEditName = !$(evt.currentTarget).is(':checked');
            $('#tb-username').prop('readonly', canEditName);
        });

        // The event log rating and token filters
        $('#event-log-filter-rating-tokens').on('click', (evt) => {
            const shouldFilter = $(evt.currentTarget).is(':checked');

            $('#event-log-table tbody tr').each((i: number, element: HTMLElement) => {
                $(element).toggle(
                    !shouldFilter
                    || $.trim($(element).find('td.rating-td').html()) != ''
                    || $.trim($(element).find('td.tokens-td').html()) != ''
                );
            });
        });
    }

    public async listIps(): Promise<void> {
        await this.loadView(`/modpanel/user/${this.userId}/ajax/ips`, {});
    }

    public async listGames(): Promise<void> {
        await this.loadView(`/modpanel/user/${this.userId}/ajax/games`, {});
    }

    public async listIpsWith(otherId: number): Promise<void> {
        await this.loadView(`/modpanel/user/${this.userId}/ajax/ips`, { with: otherId });
    }

    public async listGamesWith(otherId: number): Promise<void> {
        await this.loadView(`/modpanel/user/${this.userId}/ajax/games`, { with: otherId });
    }

    public async listStandings(): Promise<void> {
        await this.loadView(`/modpanel/user/${this.userId}/ajax/standings`, {});
    }

    private async loadView(url: string, data: JQuery.PlainObject): Promise<void> {
        try {
            const result = await this.ajaxClient.call<string>(url, data);
            $('#check-data-container').html(result);
        } catch (e) {
            const reason = (e as JQueryXHR).responseText;
            $('#check-data-container').html('<span class="error">'
                + `There was an error retrieving the information: ${reason}</span>`);
        }
    }
}
